import { createContext } from 'react';

// Cross-panel hover trace: hovering a control row tints the matching control text on the other panel (matched by text).
export interface WorkspaceTrace {
  traceText: string | null;
  setTraceText: (text: string | null) => void;
}

export const WorkspaceTraceContext = createContext<WorkspaceTrace>({
  traceText: null,
  setTraceText: () => undefined,
});
